import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  { title: 'pages.onboarding.experience.lessThan2', value: '0-2' },
  { title: 'pages.onboarding.experience.2to5', value: '2-5' },
  { title: 'pages.onboarding.experience.5to10', value: '5-10' },
  { title: 'pages.onboarding.experience.10to15', value: '10-15' },
  { title: 'pages.onboarding.experience.15plus', value: '15+' },
]

export default function ExperiencePage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.experience.title"
      layout="grid"
    />
  )
}
